import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { CoreService } from '../services/core.service';

@Injectable()
export class ManagerGuard implements CanActivate {
  constructor(
    private coreService: CoreService,
    private router: Router
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let localUser = this.coreService.getUserInfo();
    let isManager = localUser ? localUser.PreferredRole === 'Manager' : false;
    let localToken = this.coreService.getUserToken();
    if (localUser && localToken && isManager) return true;
    else {
      this.coreService.toasterMessage(
        'error',
        'guard',
        this.coreService.getTranslation('Messages.NoPermission')
      );
      this.router.navigate(['/login']);
      return false;
    }
  }
}
